<template>
  <div class="bb-project-list-tags">
    <div class="bb-project-list-tags__item">
      <SubsectionList
        :list="list"
        :vendorPage="true"
        :isError.sync="isError"
        :isErrorEl.sync="isErrorEl"
        :isColorPicker="true"
        descriptionErrorPopup="This hashtag has already been created"
        @create="createTag"
        @delete="deleteTag"
        @edit="changeTag"
        @changeColor="changeColor"
      />
    </div>
  </div>
</template>

<script>
import SubsectionList from '@/components/Settings/Services/SubsectionList/SubsectionList'
import ProjectsListTags from '@/api/ProjectsListTags/api'

export default {
  name: 'ProjectListTags',
  components: {
    SubsectionList
  },
  data: () => ({
    isError: false,
    isErrorEl: -1
  }),
  computed: {
    list: {
      get () {
        return this.$store.getters.tags
      },
      set (data) {
        this.$store.dispatch('setTags', data)
      }
    }
  },
  methods: {
    async createTag (item) {
      if (this.isError) return
      const { name } = item
      let hashTagName = `${name}`
      const regCheck = new RegExp(/^#/)
      if (!regCheck.test(hashTagName)) {
        hashTagName = `#${name}`
      }
      try {
        const { data } = await ProjectsListTags.addTag(hashTagName)
        this.list.unshift(data)
        item.name = ''
      } catch (err) {
        this.isError = true
        console.error(err)
      }
    },
    async deleteTag (index, id) {
      this.list.splice(index, 1)
      try {
        await ProjectsListTags.deleteTag(id)
      } catch (err) {
        console.error(err)
      }
    },
    checkNameTag (item) {
      const regCheck = new RegExp(/^#/)
      const { name } = item
      if (!regCheck.test(name)) item.name = `#${name}`
    },
    async changeColor (item) {
      const { color, id } = item
      const index = this.list.findIndex((el) => el.id === id)
      const currentItem = this.list[index]
      currentItem.color = color
      try {
        await ProjectsListTags.changeTag(item)
      } catch (err) {
        console.error(err)
      }
    },
    async changeTag (item) {
      if (this.isError) return
      this.checkNameTag(item)
      const { name, id } = item
      const index = this.list.findIndex((el) => el.id === id)
      const currentItem = this.list[index]
      const copyName = currentItem.name
      currentItem.name = name
      try {
        await ProjectsListTags.changeTag(item)
        this.isErrorEl = -1
      } catch (err) {
        this.isErrorEl = index
        currentItem.name = copyName
        console.error(err)
      }
    },
    async getTags () {
      try {
        const {data} = await ProjectsListTags.getTags()
        this.list = data
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    this.getTags()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-project-list-tags {

    &__item {
      max-width: 511px;
      width: 100%;

      &:first-child {
        margin-left: -4px;
      }

      &:last-child {
        margin-right: -12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Tags/ProjectListTags/ProjectListTags.vue